import styled from 'styled-components';
import { black, darkgray, violet } from '@styles/colors';

export const Heading = styled.h2`
  font-family: 'BigCaslon';
  font-size: 2rem;
  line-height: 2.5rem;
  font-weight: 500;
  position: relative;
  color: ${black};
  margin-bottom: 30px;
  &:after{
    content:'';
    display: block;
    position: absolute;
    width:45px;
    height:3px;
    bottom: -16px;
    left: 0;
    background-color:${violet};
  }
`;

export const HeadingCenter = Heading.extend`
  text-align: center;
  &:after{
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const HeadingRight = Heading.extend`
  &:after{
    right: 0;
    left: auto;
  }
`;

export const Paragraph = styled.p`
  margin-top: 20px;
  margin-bottom: 20px;
  font-family: 'Avenir';
  font-size: 1.125rem;
  line-height: 1.625rem;
  font-weight: normal;
  color: ${black};
  b {
    font-weight: 900;
  }
`;

export const ParagraphMinItalic = styled.p`
  font-family: 'Avenir';
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: normal;
  font-style: italic;
  color: ${darkgray};
  b {
    font-weight: 900;
  }
`;

export const CardHeading = styled.h3`
  margin-bottom:24px;
  font-family: 'Avenir';
  font-size: 1.5rem;
  line-height: 2.2rem;
  font-weight: 900;
  color: ${black};
`;

export const SmallCardHeading = styled.h4`
  font-family: 'BigCaslon';
  font-size: 1.625rem;
  line-height: 2rem;
  font-weight: 500;
  color: ${black};
  margin-bottom: 16px;
`;

export const SmallCardParagraph = styled.p`
  font-family: 'Avenir';
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: normal;
  color: ${black};
`;

export const EspaceProSmallHeading = styled.h4`
  font-family: 'BigCaslon';
  font-size: 1.625rem;
  line-height: 2rem;
  font-weight: 500;
  color: ${black};
  margin-bottom: 16px;
`;



// WEBPACK FOOTER //
// src/app/src/components/Typos/Typos.s.ts